export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_TYPE = 'AUTH_TYPE';
export const OTP_SUCCESS = "OTP_SUCCESS";
export const DOWNLOADS_JSON = "DOWNLOADS_JSON"
export const DOWNLOADS_EXCEPTION = "DOWNLOADS_EXCEPTION";
export const DOWNLOADS_CLEAR = "DOWNLOADS_CLEAR"
export const PROPOSAL_COUNT = "PROPOSAL_COUNT";
export const SELECTED_PROPOSALS = "SELECTED_PROPOSALS";
export const LOADER_TRUE = "LOADER_TRUE";
export const LOADER_FALSE = "LOADER_FALSE";
export const CHANGE_SELECTION = "CHANGE_SELECTION";
export const CREATEAPP = "CREATEAPP";
export const CREATEAPP_CLEAR = "CREATEAPP_CLEAR";
export const PROPOSAL_DATA = "PROPOSAL_DATA";
export const PROPOSAL_DATA_CLEAR="PROPOSAL_DATA_CLEAR"
export const IMG_DOWNLOAD = "IMG_DOWNLOAD";
export const IFSC_DATA = "IFSC_DATA";
export const TID_DATA = "TID_DATA";
export const FINCARE_HISTORY = "FiNCARE_HISTORY";
export const LOGS = "LOGS";
export const LOGS_CLEAR = "LOGS_CLEAR";
export const SWITCH_API_DATA = "SWITCH_API_DATA";
export const FETCH_PAYMENT_LOADER = "FETCH_PAYMENT_LOADER";
export const PAYMENT_PAYLOAD = "PAYMENT_PAYLOAD";
export const PAYMENT_MSG = "PAYMENT_MSG";
export const PAYMENT_METHOD_LIST = "PAYMENT_METHOD_LIST";
export const SMS_EMAIL_LOGS = "SMS_EMAIL_LOGS";
export const PRODUCT_TYPE_LIST = "PRODUCT_TYPE_LIST";
export const PRODUCT_LIST = "PRODUCT_LIST";
export const PAYMENT_CHECK = "PAYMENT_CHECK";
export const PAYMENT_REMAINING = "PAYMENT_REMAINING";
export const IFSC_PAYMENT = "IFSC_PAYMENT";
export const PAYMENT_D2C_OFFLINE= "PAYMENT_D2C_OFFLINE";
export const FETCH_PROPOSAL_DETAIL= "FETCH_PROPOSAL_DETAIL";
export const ENACH_UPDATE = "ENACH_UPDATE";
export const FETCH_APP_STATUS = "FETCH_APP_STATUS";
export const AGENT_LOGIN = "AGENT_LOGIN";
export const BYPASS_CONSENT = "BYPASS_CONSENT";
export const EDC_RETRIGGER = "EDC_RETRIGGER";
export const BYPASS_OTP = "BYPASS_OTP";
export const FREEZE_DATA = "FREEZE_DATA";



